import { render, staticRenderFns } from "./PriceOverride.vue?vue&type=template&id=fb60c118&scoped=true&"
import script from "./PriceOverride.vue?vue&type=script&lang=js&"
export * from "./PriceOverride.vue?vue&type=script&lang=js&"
import style0 from "./PriceOverride.vue?vue&type=style&index=0&id=fb60c118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb60c118",
  null
  
)

export default component.exports